import { Helper } from '../Helper';
export class ArrFilterFuncHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.getCallable({}));
        sb.emitOp(node, 'SWAP');
        sb.emitOp(node, 'UNPACK');
        sb.emitOp(node, 'DUP');
        sb.emitOp(node, 'INC');
        sb.emitOp(node, 'ROLL');
        sb.emitOp(node, 'SWAP');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'NEWARRAY');
        sb.emitOp(node, 'SWAP');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'GT');
            },
            each: (innerOptions) => {
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'OVER');
                sb.emitHelper(node, innerOptions, sb.helpers.wrapNumber);
                sb.emitPushInt(node, 5);
                sb.emitOp(node, 'ROLL');
                sb.emitOp(node, 'TUCK');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PACK');
                sb.emitPushInt(node, 5);
                sb.emitOp(node, 'PICK');
                sb.emitHelper(node, innerOptions, sb.helpers.if({
                    condition: () => {
                        sb.emitHelper(node, innerOptions, sb.helpers.call);
                        sb.emitHelper(node, innerOptions, sb.helpers.toBoolean({ type: undefined }));
                    },
                    whenTrue: () => {
                        sb.emitOp(node, 'OVER');
                        sb.emitOp(node, 'SWAP');
                        sb.emitOp(node, 'APPEND');
                    },
                    whenFalse: () => {
                        sb.emitOp(node, 'DROP');
                    },
                }));
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'INC');
                sb.emitOp(node, 'ROT');
            },
            cleanup: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'NIP');
                if (!optionsIn.pushValue) {
                    sb.emitOp(node, 'DROP');
                }
            },
        }));
    }
}

//# sourceMappingURL=ArrFilterFuncHelper.js.map
